// import { Card, Col, Menu, Row, Statistic, Tabs, Collapse, Tooltip } from 'antd';
import moment from 'moment';
import 'moment/locale/ru';
import React, { } from 'react';
import { createUseStyles } from 'react-jss';
import { QueryDetail, QueryOrder, useAuth } from 'fennec-ui';
import Icofont from 'react-icofont';
import { Action } from 'fennec-ui'
import ZakazPreview from '../../../../../forms/ZakazPreview'
import { CollectionServerMobile } from 'fennec-ui';
import { getIndexColorLighter } from '../../../../../../common/Tool';

var _ = require('lodash');


const useStyles = createUseStyles({
	block: {
		'& .buttons': {
			marginBottom: "10px"
		},
	},
	ticket: {
		padding: "5px 0px",
		display: "flex",
		cursor: "pointer",
		'&:hover': {
			backgroundColor: "#f9f9f9"
		}
	},
	ticketHeader: {
	},
	ticketName: {

	},
	collapsePanel: {
		'& .ant-collapse-content > .ant-collapse-content-box': {
			padding: "6px"
		},
		'&.ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box': {
			paddingTop: "0px",
			paddingBottom: "0px"
		}
	},
	listItemClass: {
		'&.ant-list-item': {
			display: "block"
		}
	}
})


export default function Orders(props) {
	const classes = useStyles();
	const auth = useAuth();

	// const meta = useSelector(state => state.meta);
	// const [orders, setOrders] = React.useState();
	// useEffect(() => {
	// 	GET(auth, "/api/zakaz/sentorpayment?s-status.ID=asc&s-dataZakaza=desc", ({ data }) => {
	// 		if (data) {
	// 			setOrders(data);
	// 		}
	// 	}, errorCatch)
	// }, []);

	// /api/zakaz/bynumber/{nomer}

	const orderStatus = (item) => {
		let paymentStateID = 0
		if (item.ekvairingZakaz && item.ekvairingZakaz[0]) {
			paymentStateID = item.ekvairingZakaz[0].paymentStateID
		}

		if (item.statusID === 4) { // Завершен
			return (
				// <Tooltip title={item.status.opisanie}>
				<Icofont icon="check-circled" />
				// </Tooltip>
			)
		}
		if (item.statusID == 5) { // Ошибка оплаты
			return (
				// <Tooltip title={item.status.opisanie}>
				<Icofont icon="close-circled" />
				// </Tooltip>
			)
		}

		if (item.statusID === 2) { // Оплата возвращена
			return (
				// <Tooltip title={item.status.opisanie}>
				<Icofont icon="close-circled" />
				// </Tooltip>
			)
		} else if (paymentStateID) { //Если есть объект эквайринга
			if (paymentStateID === 2) { // Новый
				return (
					<Icofont icon="clock-time" />
				)
			}
			if (paymentStateID === 3) { // Оплачен
				return (
					<Icofont icon="pay" />
				)
			}
			if (paymentStateID === 4) { // Отменен
				return (
					<Icofont icon="close-circled" />
				)
			}
		} else {
			if (item.statusID === 1) { // Новый
				return (
					// <Tooltip title={item.status.opisanie}>
					<Icofont icon="clock-time" />
					// </Tooltip>
				)
			}
			if (item.statusID === 3) { // Оплачен
				return (
					// <Tooltip title={item.status.opisanie}>
					<Icofont icon="pay" />
					// </Tooltip>
				)
			}
		}
	};

	const orderStatusSumma = (item) => {
		let paymentStateID = 0
		if (item.ekvairingZakaz && item.ekvairingZakaz[0]) {
			paymentStateID = item.ekvairingZakaz[0].paymentStateID
		}
		var color = getIndexColorLighter(item?.promokodSsilka?.ID || 1, 0.05)
		if (item.statusID === 2) { // Оплата возвращена
			return (
				<div>
					<div style={{ alignSelf: "flex-start", color: "#7c7c7c", textAlign: "end", padding: "0px 0px 0px 25px", fontWeight: "400", fontSize: "11px" }}>
						Оплата возвращена:
					</div>
					<div style={{ alignSelf: "flex-start", color: "darkblue", textAlign: "end", padding: "0px 0px 0px 25px", fontWeight: "500", fontSize: "14px" }}>
						<div style={{ color: "#7c7c7c" }}>{Number(item.obshchayaSumma.toFixed(2)).toLocaleString('ru', { style: 'currency', currency: 'RUB' })}</div>
					</div>
					{item?.promokod && <div style={{ display: "flex", justifyContent: "end" }}>
						<div style={{ fontSize: "12px", textAlign: "end", color: "rgba(0, 0, 0, 0.55)", backgroundColor: color, border: "1pz solid grey", borderRadius: "4px", padding: "2px 4px" }}>{item?.promokod}</div>
					</div>}
				</div>)
		} else if (item.statusID === 3 || item.statusID === 4) { // Оплачен
			return (
				<div>
					<div style={{ alignSelf: "flex-start", color: "rgb(63, 134, 0)", textAlign: "end", padding: "0px 0px 0px 25px", fontWeight: "400", fontSize: "11px" }}>
						Оплачено:
					</div>
					<div style={{ alignSelf: "flex-start", color: "darkblue", textAlign: "end", padding: "0px 0px 0px 25px", fontWeight: "500", fontSize: "14px" }}>
						<div style={{ color: "rgb(63, 134, 0)" }}>{item.obshchayaSumma.toLocaleString()} руб.</div>
					</div>
					{item?.promokod && <div style={{ display: "flex", justifyContent: "end" }}>
						<div style={{ fontSize: "12px", textAlign: "end", color: "rgba(0, 0, 0, 0.55)", backgroundColor: color, border: "1pz solid grey", borderRadius: "4px", padding: "2px 4px" }}>{item?.promokod}</div>
					</div>}
				</div>)
		} else if (item.statusID == 5) { // Ошибка оплаты
			return (
				<div>
					<div style={{ alignSelf: "flex-start", color: "#ff4d4f", textAlign: "end", padding: "0px 0px 0px 25px", fontWeight: "400", fontSize: "11px" }}>
						Ошибка оплаты:
					</div>
					<div style={{ alignSelf: "flex-start", color: "darkblue", textAlign: "end", padding: "0px 0px 0px 25px", fontWeight: "500", fontSize: "14px" }}>
						<div style={{ color: "#ff4d4f" }}>{item.obshchayaSumma.toLocaleString()} руб.</div>
					</div>
					{item?.promokod && <div style={{ display: "flex", justifyContent: "end" }}>
						<div style={{ fontSize: "12px", textAlign: "end", color: "rgba(0, 0, 0, 0.55)", backgroundColor: color, border: "1pz solid grey", borderRadius: "4px", padding: "2px 4px" }}>{item?.promokod}</div>
					</div>}
				</div>)
		} else if (paymentStateID) { //Если есть объект эквайринга
			if (paymentStateID === 2) { // Новый
				return (
					<div style={{ flex: "130px" }}>
						<div style={{ alignSelf: "flex-start", color: "#eb8100", textAlign: "end", padding: "0px 0px 0px 15px", fontWeight: "400", fontSize: "11px" }}>
							К оплате:
						</div>
						<div style={{ alignSelf: "flex-start", color: "darkblue", textAlign: "end", padding: "0px 0px 0px 15px", fontWeight: "500", fontSize: "14px" }}>
							<div style={{ color: "#eb8100" }}>{Number(item.obshchayaSumma.toFixed(2)).toLocaleString('ru', { style: 'currency', currency: 'RUB' })}</div>
						</div>
						{item?.promokod && <div style={{ display: "flex", justifyContent: "end" }}>
							<div style={{ fontSize: "12px", textAlign: "end", color: "rgba(0, 0, 0, 0.55)", backgroundColor: color, border: "1pz solid grey", borderRadius: "4px", padding: "2px 4px" }}>{item?.promokod}</div>
						</div>}
					</div>)
			}
			if (paymentStateID === 3) { // В процессе оплаты
				return (
					<div>
						<div style={{ alignSelf: "flex-start", color: "#0095ff", textAlign: "end", padding: "0px 0px 0px 25px", fontWeight: "400", fontSize: "11px" }}>
							Оплата:
						</div>
						<div style={{ alignSelf: "flex-start", color: "darkblue", textAlign: "end", padding: "0px 0px 0px 25px", fontWeight: "500", fontSize: "14px" }}>
							<div style={{ color: "#0095ff" }}>{item.obshchayaSumma.toLocaleString()} руб.</div>
						</div>
						{item?.promokod && <div style={{ display: "flex", justifyContent: "end" }}>
							<div style={{ fontSize: "12px", textAlign: "end", color: "rgba(0, 0, 0, 0.55)", backgroundColor: color, border: "1pz solid grey", borderRadius: "4px", padding: "2px 4px" }}>{item?.promokod}</div>
						</div>}
					</div>)
			}
			if (paymentStateID === 4) { // Отменен
				return (
					<div style={{ flex: "130px" }}>
						<div style={{ alignSelf: "flex-start", color: "#ff4d4f", textAlign: "end", padding: "0px 0px 0px 15px", fontWeight: "400", fontSize: "11px" }}>
							Отменен:
						</div>
						<div style={{ alignSelf: "flex-start", color: "darkblue", textAlign: "end", padding: "0px 0px 0px 15px", fontWeight: "500", fontSize: "14px" }}>
							<div style={{ color: "#ff4d4f" }}>{Number(item.obshchayaSumma.toFixed(2)).toLocaleString('ru', { style: 'currency', currency: 'RUB' })}</div>
						</div>
						{item?.promokod && <div style={{ display: "flex", justifyContent: "end" }}>
							<div style={{ fontSize: "12px", textAlign: "end", color: "rgba(0, 0, 0, 0.55)", backgroundColor: color, border: "1pz solid grey", borderRadius: "4px", padding: "2px 4px" }}>{item?.promokod}</div>
						</div>}
					</div>)
			}
		} else {
			if (item.statusID === 1) { // Новый
				return (
					<div style={{ flex: "130px" }}>
						<div style={{ alignSelf: "flex-start", color: "#eb8100", textAlign: "end", padding: "0px 0px 0px 15px", fontWeight: "400", fontSize: "11px" }}>
							К оплате:
						</div>
						<div style={{ alignSelf: "flex-start", color: "darkblue", textAlign: "end", padding: "0px 0px 0px 15px", fontWeight: "500", fontSize: "14px" }}>
							<div style={{ color: "#eb8100" }}>{Number(item.obshchayaSumma.toFixed(2)).toLocaleString('ru', { style: 'currency', currency: 'RUB' })}</div>
						</div>
						{item?.promokod && <div style={{ display: "flex", justifyContent: "end" }}>
							<div style={{ fontSize: "12px", textAlign: "end", color: "rgba(0, 0, 0, 0.55)", backgroundColor: color, border: "1pz solid grey", borderRadius: "4px", padding: "2px 4px" }}>{item?.promokod}</div>
						</div>}
					</div>)
			}
		}
	};

	const filters = React.useCallback(() => [
		{
			name: "obshchayaSumma",
			filterType: "range",

			func: ["min", "max"],
			// min: -25,
			// max: 10000,
			// step: 7,
			// step: 1000,

			sort: true,
			filter: true,
		},
		{
			name: "dataZakaza",
			type: "date",
			filterType: "range",
			sort: true,
			filter: true,
			sorted: "DESC"
		},
		{
			name: "nomerZakaza",
			sort: true,
			filter: true,
		},
		{
			name: "ekvairingZakaz.nomer",
			filter: true,
		},
		{
			name: "status",
			filterType: "group",
			// source: "/api/query/zakazstatus",
			display: (o) => o.opisanie,
			sort: true,
			filter: true,
		},
		{
			name: "ekvairingZakaz.paymentState",
			filterType: "group",
			// source: "/api/query/zakazstatus",
			display: (o) => o.opisanie,
			filter: true,
		},
		{
			name: "meropriyatie.mestoProvedeniya",
			filterType: "group",
			queryFilter: [
				QueryDetail("model"),
				QueryOrder("name", "ASC"),
				// QueryParam("w-region","77")
			],
			// source: "/api/query/city",
			display: (o) => o.name,
			sort: true,
			filter: true,
		}
	], []);
	const title = React.useCallback(() => (<div style={{
		color: "rgba(0, 0, 0, 0.85)",
		fontWeight: "500",
		fontSize: "16px"
	}}>
		Заказы
	</div>), []);

	const emptyArray = React.useCallback(() => [], []);
	return (
		<>
			<div style={{ padding: "10px 5px", height: "100%" }}>
				<CollectionServerMobile
					auth={auth}
					name={"Zakaz"}
					source={"/api/zakaz/sentorpayment"}

					filters={filters}

					size={"small"}
					mode={"list"}
					titleFunc={title}
					render={(item, idx, options) => {
						const _modal = {
							width: "750px"
						};
						return (<div key={idx} style={{ width: "100%" }} >
							<Action
								auth={auth}
								titles={{ header: "Заказ №" + item.nomerZakaza + " от " + moment(item.dataZakaza).format("DD.MM.YYYY HH:mm:ss") }}
								action={() => {
								}}
								object={item}
								options={options}
								modal={_modal}

								readonly={true}
								mode={"func"}
								noAntForm={true}
								form={ZakazPreview}
								trigger={(click) => {
									return (
										<div className={classes.ticket} onClick={click}>
											<div style={{ flex: "auto" }}>
												<div style={{ fontWeight: "500" }}>
													<div style={{ display: "flex", justifyContent: "space-between" }}>
														<div>
															{item.status && <span style={{ paddingRight: "5px" }}>
																{orderStatus(item)}
															</span>}
															№{item.nomerZakaza} от {moment(item.dataZakaza).format("DD.MM.YYYY HH:mm:ss")}
														</div>
														<div style={{ flex: "auto", margin: "10px 10px", height: "1px", borderColor: "#f0f0f0", borderWidth: "1px", borderStyle: "dotted" }}></div>
													</div>
												</div>
												{(item.ekvairingZakaz && item.ekvairingZakaz[0]) && <div style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
													Оплата заказа №{item.ekvairingZakaz[0].nomer}
												</div>}
												{item.meropriyatie && <div style={{ fontSize: "13px", color: "rgba(0, 0, 0, 0.45)" }}>
													{item.meropriyatie.nazvanieMeropriyatiya} - {moment(item.meropriyatie.nachaloSorevnovaniya).format("DD.MM.YYYY")},  {_.get(item, "meropriyatie.mestoProvedeniya.name")}
												</div>}
											</div>
											{orderStatusSumma(item)}
										</div>
									)
								}}
							/>
						</div>)
					}}

					collectionActions={emptyArray}
					modelActions={emptyArray}
				/>
			</div>
		</>
	);
}
// CommonMainOrders.whyDidYouRender = true